import React from 'react';

import { StyledIcon } from '../StyledIcon';

export const FormDown = props => (
  <StyledIcon viewBox='0 0 24 24' a11yTitle='FormDown' {...props}>
    <polyline fill='none' stroke='#000' strokeWidth='2' points='18 9 12 15 6 9' />
  </StyledIcon>
);
